// extracted by mini-css-extract-plugin
export default {"wrapper":"TasksForm_wrapper__WhKM7","container":"TasksForm_container__rj+lS","icons":"TasksForm_icons__dj-lO","drop-down-icon":"TasksForm_drop-down-icon__Q6CBT"};